import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import DashBoardsServices from "services/DashBoardsServices";


const initialState = {
  allUsers: {},
nanniesCategories: {},
 parentsCategories:{},
  nanniesRating:[],
  loading: false,
  error: null,
};


export const fetchAllUsers = createAsyncThunk(
  "dashboards/fetchAllUsers",
  async (_, { rejectWithValue }) => {
    try {
          const response = await DashBoardsServices.getAllUsers();
          return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data.data.message || "Erreur");
    }
  
  }
);
export const fetchNanniesCategories = createAsyncThunk(
  "dashboards/fetchNanniesCategories",
  async (_, { rejectWithValue }) => {
    try {
        const response = await DashBoardsServices.getNannyCategory();
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data.data.message || "Erreur");
    }
    
  }
);
export const fetchParentsCategories = createAsyncThunk(
  "dashboards/fetchParentsCategories",
  async (_,{rejectWithValue}) => {
    try {
        const response = await DashBoardsServices.getParentCategory();
        return response.data;
        
    } catch (error) {
          return rejectWithValue(error.response.data.data.message || "Erreur");
    }
    
  }
);

export const fetchNanniesRating = createAsyncThunk(
  "dashboards/fetchNanniesRating",
  async (_, { rejectWithValue }) => {
    try {
        const response = await DashBoardsServices.getNannyRating();
        return response.data;
    } catch (error) {
         return rejectWithValue(error.response.data.data.message || "Erreur");
    }
    
  }
);

// Create the DashboardsSlice slice
const DashboardsSlice = createSlice({
  name: "dashboards",
  initialState,
  reducers: {
    

    showLoading: (state) => {
      state.loading = true;
    },
    hideLoading: (state, action) => {
      state.loading = false;
    },
    hideError: (state, action) => {
     
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.allUsers = action.payload;
      })
      .addCase(fetchAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchNanniesCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNanniesCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.nanniesCategories = action.payload;
      })
      .addCase(fetchNanniesCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchParentsCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchParentsCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.parentsCategories = action.payload;
      })
      .addCase(fetchParentsCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchNanniesRating.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNanniesRating.fulfilled, (state, action) => {
        state.loading = false;
        state.nanniesRating = action.payload;
      })
      .addCase(fetchNanniesRating.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// // Export the async thunks
// export { fetchAllUsers, fetchNanniesCategories };

export default DashboardsSlice.reducer;
export const { showLoading, hideLoading, hideError  } = DashboardsSlice.actions;